<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-商家会员-添加
    -->
    <el-dialog
    title="修改商家会员"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form"  label-width="100px">
      <div class="common-form">修改商家会员</div>
      <el-form-item label="商家会员名称" prop="name"
      :rules="[{ required: true, message: '请输入商家会员名称' }]"
      ><el-input v-model="form.name" 
        placeholder="请输入商家会员名称" class="max-w460"></el-input></el-form-item>

        <el-form-item label="商家会员编号" prop="numb"
      :rules="[{ required: true, message: '请输入商家会员编号' }]"
      ><el-input v-model="form.numb" 
        placeholder="请输入商家会员编号" class="max-w460"></el-input></el-form-item>

     

        <el-form-item label="头像" prop="image_url" >
        <div>
          <el-button type="primary" @click="openUpload(1)">上传图片</el-button>
          <img :src="form.image_url" class="mt10" width="120px;" v-if="isImg" :isImg="isImg" />
        </div>
      </el-form-item>  

      <el-form-item label="福利金" prop="welfare"    :rules="[{ required: true, message: '请输入福利金' }]">
          <el-input v-model="form.welfare" 
        placeholder="请输入福利金" class="max-w460"
     ></el-input></el-form-item>

      <el-form-item label="性别">
        <el-select v-model="form.gender" placeholder="请选择性别" style="width: 108px;">
          <el-option v-for="(item, index) in sex" :key="index" :label="item" :value="index"></el-option>
        </el-select>
      </el-form-item>


        <el-form-item label="手机号" prop="mobile"    :rules="[{ required: true, message: '请输入手机号' }]">
          <el-input v-model="form.mobile" 
        placeholder="请输入手机号" class="max-w460"
     ></el-input></el-form-item>


        <el-form-item label="职位" prop="post"><el-input v-model="form.post" 
        placeholder="请输入职位" class="max-w460"
     ></el-input></el-form-item>

       <!-- 关联商家 -->
       <Supply :form="form"  ></Supply>


         <!-- 关联会员 -->
         <el-form-item label="关联会员" >
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">关联会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img v-if="user_info.avatarUrl" :src="user_info.avatarUrl" width="100" height="100" />
            <div>{{ user_info.nickName }}</div>
          </div>
        </el-row>
        <el-button @click="remove" v-if="form.user_id!=''">移除会员</el-button>
      </el-form-item>



        <el-form-item label="入职时间" prop="time" :rules="[{ required: true, message: '请选择入职时间' }]">
          <el-date-picker
                    v-model="form.time"
                    align="right"
                    type="date"
                    placeholder="选择日期"
                    format="yyyy-MM-dd" 
                    value-format="yyyy-MM-dd"
                    >
                  </el-date-picker>
        </el-form-item>


        <el-form-item label="在职状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">未入职</el-radio>
            <el-radio :label="1">在职</el-radio>
            <el-radio :label="2">离职</el-radio>
          </el-radio-group>
        </el-form-item>





      <el-form-item label="排序" prop="sort"  ><el-input v-model="form.sort" 
        placeholder="请输入排序" class="max-w460"
     ></el-input></el-form-item>
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
      <!--上传图片组件-->
      <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    <GetUser :is_open="open_user" :multi="false" @close="closeDialogFunc"></GetUser>
  </div>
</el-dialog>
  
</template>

<script>
import StaffApi from '@/api/staff.js';
import Upload from '@/components/file/Upload';
import GetUser from '@/components/user/GetUser.vue';
import Supply from './part/Supply';
export default {
  components: {
    Upload,
    GetUser,
    Supply
  },
  data() {
    return {

      /*form表单数据*/
      form: {
        name: '',
        image_id: '',
        image_url:"",
        numb:"",
        intro:"",
        linkman:"",
        mobile:"",
        post:"",
        time:"",
        user_id:"",
        status:0,
        sort:50,
        supply_id:0,
        supply:{},
        welfare:0,
      },
      loading: false,
      dialogVisible:false,
            /*性别列表*/
            sex: ['女', '男'],
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      user_info:{
        avatarUrl:"",
        nickName:""
      },
      open_user:false,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","staff_id"],
  methods: {
       /*上传*/
       openUpload(upload_type) {
      this.isupload = true;
    },

    
    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image_url = e[0].file_path;
        this.isImg = true;

      }
      this.isupload = false;
    },

      /*打开弹出层*/
      addClick() {
        this.open_user = true;
      },
       /*关闭获取用户弹窗*/
       closeDialogFunc(e) {
        console.log("e",e)
        if (e.type != 'error') {
          this.user_info = e.params;
          this.form.user_id = e.params.user_id;
        }
        this.open_user = false;
      },
      remove(){
        console.log("移除");
        this.user_info = {
          nickName:"",
          avatarUrl:""
        }
        this.form.user_id = "";
      },



     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      StaffApi.detail({staff_id: self.staff_id},true).then(res => {
          self.form = res.data;
          self.user_info = res.data.user_info
          self.form.time = new Date(self.form.time);
          self.loading = false;
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.staff_id = self.staff_id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          StaffApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":""});
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/staff/index/edit.vue